export const easeOutSine = (x) => Math.sin((x * Math.PI) / 2)
export const easeInOutQuad = (t) =>
  t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
export const easeInQuad = (t) => t * t
export const easeOutQuad = (t) => t * (2 - t)
